// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8fG1-","col":"styles_col__2MdLs"};